import type { JSX } from "react";

import { cn } from "@/shared/lib/cn";

const SIZE = { sm: "h-4 w-4", md: "h-5 w-5", lg: "h-8 w-8" } as const;

interface SpinnerProps {
  size?: keyof typeof SIZE;
  className?: string;
  label?: string;
}

export function Spinner({ size = "md", className, label = "Loading" }: SpinnerProps): JSX.Element {
  return (
    <span
      role="status"
      aria-label={label}
      data-testid="spinner"
      className={cn("inline-block", className)}
    >
      <svg
        className={cn("animate-spin text-[var(--brand-500)]", SIZE[size])}
        viewBox="0 0 24 24"
        fill="none"
      >
        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeOpacity="0.2" strokeWidth="3" />
        <path
          d="M22 12a10 10 0 0 0-10-10"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
        />
      </svg>
    </span>
  );
}
